import React from 'react';
import { Link } from 'react-router-dom';
import {
  getPathnameFromUrl,
  isExternalUrl,
  isInternalUrl,
  isPathFromSpa,
} from 'common/helpers/resolveHost';

interface Props {
  url: string;
  text?: string;
  disabled?: boolean;
  children?: React.ReactNode;
  className?: string;
}

const PageLink = ({ url, text, children, className }: Props) => {
  if (isExternalUrl(url) && !isPathFromSpa(url)) {
    return (
      <a href={url} target="_self" rel="noreferrer" className={className}>
        {text}
        {children}
      </a>
    );
  }
  if (isExternalUrl(url) && isPathFromSpa(url)) {
    const path = getPathnameFromUrl(url);
    return (
      <Link to={path} className={className}>
        {text}
        {children}
      </Link>
    );
  }
  // if (isPathFromSpa(url)) {
  //   return (
  //     <Link to={url} className={className}>
  //       {text}
  //     </Link>
  //   );
  // }
  return (
    <a href={url} className={className}>
      {text}
      {children}
    </a>
  );
};

export default PageLink;
